import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getByCompany() {
        try
        {            
            const response = await axios.get(`Allocation/paygrades`,
            {
                headers: {
                    'page_key': pageKeys.paygrades
                }
            })         
            return response
        }
        catch (error)
        {
            console.log('paygrades api getByCompany error')
            throw error
        }
    },
    async add(data) {
        try
        {            
            const response = await axios.post(`Allocation/paygrades`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.paygrades
                }
            })     
            return response
        }
        catch (error)
        {
            console.log('paygrades api add error')
            throw error
        }
    },
    async update(data) {
        try
        {            
            const response = await axios.patch(`Allocation/paygrades`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.paygrades
                }
            })     
            return response
        }
        catch (error)
        {
            console.log('paygrades api update error')
            throw error
        }
    }
}